var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prevRouter",on:{"click":function($event){return _vm.prevPage()}}},[_c('ion-icon',{attrs:{"name":"chevron-back-outline"}}),_c('span',[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }